import { render, staticRenderFns } from "./NbBannerLink.vue?vue&type=template&id=1396122e&scoped=true&"
import script from "./NbBannerLink.vue?vue&type=script&lang=js&"
export * from "./NbBannerLink.vue?vue&type=script&lang=js&"
import style0 from "./NbBannerLink.vue?vue&type=style&index=0&id=1396122e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1396122e",
  null
  
)

export default component.exports